import { Component, NgZone, OnInit } from '@angular/core';
import { LiveEvent } from '../Models/live-event';
import { LiveEventsService } from '../Shared/live-events.service';

@Component({
  selector: 'app-live-events-send',
  templateUrl: './live-events-send.component.html',
  styleUrls: ['./live-events-send.component.css']
})
export class LiveEventsSendComponent implements OnInit {

  constructor(private liveEventService: LiveEventsService,
    private _ngZone: NgZone) { }

  ngOnInit(): void {
  }
  sendMessage(val: string): void {
    let ev = new LiveEvent();
    ev.deviceName = "Test";
    ev.eventDetail = "Device is sending event " + val;
    ev.eventDate = new Date().toLocaleString();
    this.liveEventService.sendMessage(ev);
  }
}
